import { createAction, props } from '@ngrx/store';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { IThirdPartyEid, IThirdPartySearchCompany } from '@ruby/modules/third-party/models/third-party.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

export const searchCompanies = createAction(
  '[Third Party Company] Search Companies',
  props<{ data: string }>()
);

export const searchCompaniesSuccess = createAction(
  '[Third Party Company] Search Companies Success',
  props<{ data: Array<IThirdPartySearchCompany> }>()
);

export const searchCompaniesFailure = createAction(
  '[Third Party Company] Search Companies Failure',
  props<{ error: IError }>()
);

export const setCustomerCompany = createAction(
  '[Third Party] Set Customer Company',
  props<{ data: ICustomer }>()
);

export const setCompanyProvider = createAction(
  '[Third Party] Set Company Provider',
  props<{ data: IThirdPartySearchCompany }>()
);

export const requestEid = createAction(
  '[Third Party Company] Request EID',
  props<{ data: IThirdPartyEid }>()
);

export const requestEidSuccess = createAction(
  '[Third Party Company] Request EID Success'
);

export const requestEidFailure = createAction(
  '[Third Party Company] Request EID Failure',
  props<{ error: IError }>()
);

export const clearCompanyProvider = createAction(
  '[Third Party] Clear Company Provider'
);

export const clearCompanies = createAction(
  '[Third Party] Clear Companies'
);

export const clearSearch = createAction(
  '[Third Party] Clear Search'
);
